<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select v-model="selectedBranch" :options="branchOptions" name="branch" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">Phòng ban</label>
                <v-select v-model="selectedDepartment" :options="departmentOptions" name="department" :clearable="false"
                          class="elipsisText">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                <label class="vs-input--label">Bác sĩ</label>
                <v-select v-model="selectedDoctor" :options="doctorOptions" name="doctor" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-0 mt-2">
                <label class="vs-input--label">Khách hàng</label>
                <v-select class="w-full" v-model="selectedCustomer" :options="paginated"
                          :clearable="false" :filterable="false"
                          @open="onOpen"
                          @close="onClose"
                          @search="searchCustomer">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    <template #list-footer>
                        <li v-show="hasNextPage" ref="load" class="loader">
                            Loading more options...
                        </li>
                    </template>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">Trạng thái</label>
                <v-select v-model="selectedStatus" :options="statusOptions" name="status" :clearable="false"></v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                   @update="dateRangePicker" v-model="dateRange" class="w-full">
                </date-range-picker>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 w-1/2 lg:mt-4 sm:mt-2 mt-4">
                <vs-button class="md:mt-4 sm:mt-2" color="primary" iconPack="feather" icon="icon-search"
                           @click="searchBooking">Tìm
                    kiếm
                </vs-button>
            </div>
<!--            <div class="vx-col lg:w-1/4 md:w-2/3 w-1/2 lg:mt-4 sm:mt-2 mt-4">-->
<!--                <vs-button class="md:mt-4 sm:mt-2 float-right" color="primary"-->
<!--                           iconPack="feather" icon="icon-plus" @click="$router.push(`/user/booking-schedule-info`)"-->
<!--                           v-if="isPermissionCreateBooking">-->
<!--                    Tạo mới lịch hẹn-->
<!--                </vs-button>-->
<!--            </div>-->
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="beautyBookingData" :animateRows="true" :pagination="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :paginationPageSize="paginationPageSize"
                     :onGridReady="onGridReady" :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="beautyBookingData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    beautyBookingData.length - currentPage * paginationPageSize > 0 ? currentPage *
                                        paginationPageSize
                                        : beautyBookingData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import moment from "moment";
import Pagination from "../../../ui-elements/Pagination.vue";
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererActions,
        CellRendererStatus,
        Pagination,
    },

    data() {
        return {
            branchOptions: [],
            selectedBranchValue: null,
            departmentOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDepartmentValue: null,
            doctorOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedDoctorValue: null,
            customerOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedCustomerValue: null,
            statusOptions: [
                {value: null, label: 'Tất cả'},
                {value: 1, label: 'Chờ xử lý'},
                {value: 2, label: 'Đã xác nhận'},
                {value: 3, label: 'Đã hoàn thành'},
                {value: 4, label: 'Hủy'},
            ],
            selectedstatusValue: null,
            dateRange: {
                startDate: (new Date().setMonth(new Date().getMonth() - 1)),
                // startDate: new Date().setUTCHours(0, 0, 0, 0),
                endDate: new Date().setUTCHours(16, 59, 59, 999)
            },
            beautyBookingData: [],
            // maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 80
                },
                {
                    headerName: 'Khách hàng',
                    field: 'customerName',
                    minWidth: 250,
                },
                {
                    headerName: 'Chi nhánh',
                    field: 'organizationBranchName',
                    width: 150,
                },
                {
                    headerName: 'Bác sĩ',
                    field: 'doctorName',
                    width: 150,
                },
                {
                    headerName: 'Nhóm dịch vụ',
                    field: 'serviceBooking',
                    width: 200,
                    resizable: true
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'status',
                    cellRendererFramework: 'CellRendererStatus',
                    width: 150,
                    resizable: true
                },
                {
                    headerName: 'Ngày đặt',
                    field: 'dateBooking',
                    width: 150,
                    resizable: true
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 200,
                    cellRendererFramework: 'CellRendererActions',
                    resizable: true,
                    suppressSizeToFit: true
                },
            ],
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            observer: null,
            limit: 20,
            search: '',
            typingSearchCustomer: null,
            textTypingSearch: null,
            pageNumberCustomer: 0,
            pageSizeCustomer: 50,
            showListCustomer: false,
        }
    },

    computed: {
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value == this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                if (this.selectedBranchValue) {
                    this.getDepartmentData();
                    this.getDoctorData();
                    // this.getCustomerData();
                }
            }
        },
        selectedDepartment: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value == this.selectedDepartmentValue)),
                    value: this.departmentOptions.find(x => x.value == this.selectedDepartmentValue)
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.getDoctorData();
            }
        },
        selectedDoctor: {
            get() {
                return {
                    label: this.getLabelString(this.doctorOptions.find(x => x.value == this.selectedDoctorValue)),
                    value: this.doctorOptions.find(x => x.value == this.selectedDoctorValue)
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },
        selectedCustomer: {
            get() {
                return {
                    label: this.getLabelString(this.customerOptions.find(x => x.value === this.selectedCustomerValue)),
                    value: this.customerOptions.find(x => x.value === this.selectedCustomerValue)
                }
            },
            set(obj) {
                this.selectedCustomerValue = obj ? obj.value : null;
            }
        },
        selectedStatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.selectedstatusValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedstatusValue = obj ? obj.value : null;
            }
        },
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 50
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
        hasNextPage() {
            return true;
        },
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        if (this.$route.query.customerId) {
            this.selectedCustomerValue = parseInt(this.$route.query.customerId, 10)
        }

        await this.getDepartmentData();
        await this.getDoctorData();
        await this.getCustomerData();
        this.searchBooking();
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.searchBooking();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        }
    },

    methods: {

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.departmentOptions = [];

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', body).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        });
                    }
                    this.departmentOptions.unshift({value: null, label: 'Tất cả'});
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctorData() {
            return new Promise((resolve, reject) => {
                let url = '/beauty-booking/get-list-doctor-department';
                if (this.selectedBranchValue) {
                    url += '?organizationBranchId=' + this.selectedBranchValue
                }
                if (this.selectedDepartmentValue) {
                    url += '&departmentId=' + this.selectedDepartmentValue
                }

                this.doctorOptions = [];

                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    this.doctorOptions.unshift({value: null, label: 'Tất cả'})
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getCustomerData() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let url = '/loyalty/customer/find'
                if (this.textTypingSearch != this.search) {
                    this.textTypingSearch = this.search;
                    this.customerOptions = [
                        {value: null, label: 'Tất cả'}
                    ];
                }
                url += `?pageNumber=${this.pageNumberCustomer}&pageSize=${this.pageSizeCustomer}`;
                if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
                this.$crm.get(url).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        let customer = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.phoneNumber + ' - ' + el.fullName
                            }
                        });
                        this.customerOptions.push(...customer);
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setUTCHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setUTCHours(16, 59, 59, 999));
        },

        searchBooking() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                customerId: this.selectedCustomerValue,
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranchValue ? this.selectedBranchValue : userInfo.organizationBranchId,
                endDate: new Date(this.dateRange.endDate).toISOString(),
                performerId: this.selectedDoctorValue,
                startDate: new Date(this.dateRange.startDate).toISOString(),
                status: this.selectedstatusValue,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            }

            this.$vs.loading();
            this.$crm.post('/beauty-booking/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.beautyBookingData = res.data.content.map(el => {
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                        let branch = this.branchOptions.find(x => x.value == el.organizationBranchId);
                        el.organizationBranchName = branch ? branch.label : null;
                        el.doctorName = el.beautyBookingDetails[0].performer ? el.beautyBookingDetails[0].performer.fullName : null;
                        el.dateBooking = moment(el.beautyBookingDetails[0].bookingDate).format('DD/MM/YYYY') + ' ' + (el.beautyBookingDetails[0].startTime ? el.beautyBookingDetails[0].startTime : '');
                        el.serviceBooking = el.beautyBookingDetails[0].beautyServicePackage ? el.beautyBookingDetails[0].beautyServicePackage.name : el.beautyBookingDetails[0].beautyPackageCombo ? el.beautyBookingDetails[0].beautyPackageCombo.name : null;
                        el.customerName = el.loyaltyCustomer.phoneNumber + ' - ' + el.loyaltyCustomer.fullName;
                        return el;
                    })
                } else {
                    this.beautyBookingData = [];
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.searchBooking();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.searchBooking();
        },

        isPermissionCreateBooking() {
            return isAPI(this, constAPI.beauty_booking_create);
        },

        isPermissionUpdateBooking() {
            return isAPI(this, constAPI.beauty_booking_update);
        },

        isPermissionDeleteBooking() {
            return isAPI(this, constAPI.beauty_booking_delete);
        },

        async onOpen() {
            this.showListCustomer = true;
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            this.search = '';
            this.pageNumberCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 20;
                this.pageNumberCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomerData();
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500)
            }
        },

        async doneTypingSearch() {
            await this.getCustomerData(true);
            if (this.customerOptions.length === 1) this.selectedCustomerValue = null;
            await this.onOpen();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
        this.observer = new IntersectionObserver(this.infiniteScroll);
    },
}
</script>

<style>
.vs--single .vs__selected {
    /* max-width: 160px !important; */
    /* min-width: 150px !important; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
